// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2p5Bh","inner":"Footer_inner__1pgbE","nextIcon":"Footer_nextIcon__3byhh","innerLeft":"Footer_innerLeft__xeE4Z"};